import React from 'react';
import "../../IndividualLite.scss"
import ButtonGroup from './ButtonGroup';
import ButtonGroupNew from './ButtonGroupNew';

const FEATURES = [
    { id: 0, text: "USD Account" },
    { id: 1, text: "ACH and Domestic Wires" },
    { id: 2, text: "SWIFT Payments Globally" },
    { id: 3, text: "Cross Border Payments in 11 currencies" },
    { id: 4, text: "Digital Asset Custody" },
    { id: 5, text: "Convert Digital Assets" },
    { id: 6, text: "Instant Peer to Peer transfers" },
    { id: 7, text: "FV Bank Visa Debit Cards" },
]

const Page1 = ({ loading, hideButtons, onBackClick, onNextClick, asLabel }) => {
    return (
        <div className='pt-3'>
            <p className=''>
                {"FV Bank offers a full-featured business account with Plus onboarding to qualified applicants. If you are interested in applying for a Plus approval business account (approvals in 3-5 days), you will need to answer a few prequalification questions. These will determine if your application can be processed in our Plus program."}
            </p>

            <div className='py-3'>
                <h3>Business Account Plus Features</h3>
                <ul>
                    {
                        FEATURES.map(e => (
                            <li style={{ fontWeight: 'bold' }} key={e.id}>{e.text}</li>
                        ))
                    }
                </ul>
            </div>

       


            <div className='mt-4'>
                <ButtonGroupNew
                    onNextClick={onNextClick}
                    onBackClick={onBackClick}
                    step={1}
                    hideBackButton
                    showPageNum
                    pageNum={1}
                    isDisabled={asLabel}
                    asLabel={hideButtons}
                    loading={loading}
                />
            </div>
        </div>
    )
}

export default Page1;